export const environment = {
  production: true,
  connection: {
    name: 'Feichtinger Softline',
    host: 'https://softline.feichtinger.biz',
    port: 443,
    basePath: '/restapi/api'
  },
  androidUpdateRepository: '',
};
